(function () {
    function addAriaLabelToInputs() {
        // Select all inputs with aria-checked="false"
        const inputs = document.querySelectorAll('input[aria-checked="false"]:not([aria-label])');

        inputs.forEach(input => {
            const inputValue = input.getAttribute("value");

            if (inputValue) {
                // Set aria-label with the value attribute
                input.setAttribute("aria-label", inputValue);
                console.log(`Added aria-label="${inputValue}" to input:`, input);
            } else {
                console.warn("Input has no value attribute, aria-label not added:", input);
            }
        });

        if (inputs.length === 0) {
            console.log("No matching inputs found with aria-checked='false'.");
        }
    }

    // Initial check
    addAriaLabelToInputs();

    // Keep observing for new inputs dynamically added to the DOM
    const observer = new MutationObserver(addAriaLabelToInputs);
    observer.observe(document.body, { childList: true, subtree: true });

    console.log("Script for adding aria-label to inputs is running...");
})();

 

document.addEventListener('DOMContentLoaded', function () {
    // Select all radio inputs within the fieldset
    const radioInputs = document.querySelectorAll('fieldset.single-option-radio input[type="radio"]');
    
    // Function to update aria-checked attributes
    function updateAriaChecked() {
        radioInputs.forEach(radio => {
            if (radio.checked) {
                radio.setAttribute('aria-checked', 'true');
                const label = document.querySelector(`label[for="${radio.id}"]`);
                if (label) label.setAttribute('aria-checked', 'true'); // Optional: Update label for better support
            } else {
                radio.setAttribute('aria-checked', 'false');
                const label = document.querySelector(`label[for="${radio.id}"]`);
                if (label) label.setAttribute('aria-checked', 'false'); // Optional
            }
        });
    }

    // Add event listeners to update on change
    radioInputs.forEach(radio => {
        radio.addEventListener('change', updateAriaChecked);
    });

    // Initial update on page load
    updateAriaChecked();
});

